import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from './../http-client/http-client.service';
import { Tutor } from '../../models/tutors/Tutor';

@Injectable()
export class TutorService {

    public tutors: Tutor[];
    public tutorObject: any;

    constructor(
        private http: HttpClientService
    ) {
        this.tutors = [];
        this.tutorObject = {};
    }

    public getAll(): Observable<Tutor[]> {
        if (!!this.tutors && this.tutors.length > 0) {
            return Observable.create((observer: Subscriber<Tutor[]>) => {
                observer.next(this.tutors);
                observer.complete();
            });
        }
        const url = 'tutors/all';
        return this.http.get(url).map(response => {
            let r = response.json();
            if (r.ResultCode === 1) {
                this.tutors = r.Result;
                console.log(this.tutors);
                this.tutorObject = this.tutors.reduce((result, s) => {
                    result[String(s.Id)] = result[String(s.Id)] || {};
                    result[String(s.Id)] = s;
                    return result;
                }, {});
            } else {
                console.error('StudentService > getAll > response', r);
            }
            return this.tutors;
        }).catch(this.handleError);
    }

    public getById(Id: string): Observable<Tutor> {
        if (!!this.tutors && this.tutors.length > 0 && !!this.tutors.find(s => s.Id == Id)) {
            return Observable.create((observer: Subscriber<Tutor>) => {
                observer.next(this.tutors.find(s => s.Id == Id));
                observer.complete();
            });
        }
        const url = 'tutors/id/' + Id;
        return this.http.get(url).map(response => {
            let r = response.json();
            let Tutor = null;
            if (r.ResultCode === 1 && r.Result != null) {
                Tutor = r.Result;   
                let alreadyExist = this.tutors.find(s => s.Id == Tutor.Id);
                console.log('---------------------->****' + alreadyExist);
                if (!alreadyExist) {
                    this.tutors.push(Tutor);
                    this.tutorObject[Tutor.id] = Tutor;
                }
                console.log('TutorService******************* > getById > response', Tutor);
            } else {
                console.error('TutorService > getById > response', r);
            }
            return Tutor;
        }).catch(this.handleError);
    }

    public add(firstName: string, lastName: string, documentNumber: string, phoneNumber: string, mobilePhoneNumber: string, anotherContactPhone: string, birthdate: Date, personGenderId: number, photo: string, address: string, relationshipId: number) {
        const url = 'tutors/add';
        return this.http.post(url, {
            FirstName: firstName,
            LastName: lastName,
            DocumentNumber: documentNumber,
            PhoneNumber: phoneNumber,
            MobilePhoneNumber: mobilePhoneNumber,
            AnotherContactPhone: anotherContactPhone,
            Birthdate: birthdate,
            Photo: photo,
            PersonGenderId: personGenderId,
            Address: address,
            RelationshipId: relationshipId
        }).map(response => response.json())
        .catch(this.handleError);
    }

    public edit(id: string, firstName: string, lastName: string, documentNumber: string, phoneNumber: string, mobilePhoneNumber: string, anotherContactPhone: string, birthdate: Date, personGenderId: number, photo: string, updatedAt: Date, isActive: boolean) {
        const url = 'tutors/edit';
        return this.http.put(url, {
            Id: id,
            FirstName: firstName,
            LastName: lastName,
            DocumentNumber: documentNumber,
            PhoneNumber: phoneNumber,
            MobilePhoneNumber: mobilePhoneNumber,
            AnotherContactPhone: anotherContactPhone,
            Birthdate: birthdate,
            Photo: photo,
            PersonGenderId: personGenderId,
            isActive: isActive
        }).map(response => response.json())
        .catch(this.handleError);
    }

    public delete(id: number) {
        const url: string = 'tutors/remove/id/' + id;
        return this.http.delete(url).map(response => response.json())
            .catch(this.handleError);
    }

    public handleError(error: Response) {
        // console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

}



// WEBPACK FOOTER //
// ./src/app/main/services/tutors/tutor.service.ts